class Juicio {
  constructor(idJuicio, fechaNotificacion, caratula, expediente, nroSiniestro, tipoJuicio, idDenuncia, estado, marcaCritico, observacionCritico) {
    this.idJuicio = idJuicio
    this.fechaNotificacion = fechaNotificacion
    this.caratula = caratula
    this.expediente = expediente
    this.nroSiniestro = nroSiniestro
    this.tipoJuicio = tipoJuicio
    this.idDenuncia = idDenuncia
    this.estado = estado
    this.marcaCritico = marcaCritico
    this.observacionCritico = observacionCritico
  }
}

export default Juicio
